// import img from "./img/SLIDE_oxygene-experience-spa-casablanca-2.jpg";
import img2 from "./img/Capture.webp";


export const blogPosts = [
  
  {
  id: "salon-revetement-casablanca-2026",
  title: "UNIK SYSTEM au Salon International du Revêtement 2026",
  excerpt: "Un stand moderne et des solutions innovantes présentées à Casablanca.",
  date: "2026-01-29",
  cover: img2,
  video: "https://www.youtube.com/watch?v=EJE7BaH5akQ&list=PLG8xVcfmVtuihGNE8pA4IlRQ-qMyqZ786&index=6",
  content: `
UNIK SYSTEM a participé au Salon International du Revêtement à Casablanca le 29 janvier 2026 avec un stand moderne et élégant.

Cet événement a rassemblé les professionnels du secteur du bâtiment, de l’architecture et de la décoration intérieure autour des dernières innovations en matière de revêtements.

Le stand UNIK SYSTEM a présenté plusieurs solutions :
- Plafonds tendus techniques et décoratifs
- Murs tendus et toiles imprimées
- Revêtements acoustiques
- Solutions rétro-éclairées
- Films solaires et adhésifs

Les visiteurs ont pu découvrir la qualité des matériaux, les finitions haut de gamme et les nombreuses possibilités de personnalisation.

Cette participation a permis à UNIK SYSTEM de renforcer sa présence sur le marché et de créer de nouvelles opportunités de collaboration avec des partenaires et clients.
`
},


];
